






































































import {Vue, Component} from 'vue-property-decorator';
import AppLink from '@/components/AppLink.vue';
import TimelineBlock from '@/components/TimelineBlock.vue';

@Component({
    name: 'ResumeTimeline',
    components: {TimelineBlock, AppLink},
})
export default class ResumeTimeline extends Vue {

}
